import { render, staticRenderFns } from "./NolaNovelUpdateConfirm.vue?vue&type=template&id=dc657308&scoped=true&"
import script from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts&"
export * from "./NolaNovelUpdateConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./NolaNovelUpdateConfirm.vue?vue&type=style&index=0&id=dc657308&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc657308",
  null
  
)

export default component.exports